const GPT_MANAGEMENT_SUPPORT_IDS = [
  '4d205514-421b-4b77-bff7-4ffe107e53d1', // stas
  'f49f9dd5-a1ec-4095-a9d2-6529717f6d40', // hryhorii
  '613e4658-00de-44c3-899a-2e85965db2d1', // hryhorii algoteryx
  '51eca751-4ff0-4f43-8f13-46a5b966ac59', // maciej
  '375e818b-d107-4b53-a417-ca91f94d40a9', // anatoliy
];

const HIGH_PRIVILEGE_SUPPORT_IDS = [
  'c6d678dd-3627-4088-9a75-c3066cf764bc', // artur
  'c27f6cf0-3043-432b-9c25-628331b9f6df', // diana
  'fe85b493-dd7c-4f8f-8eec-486a6ae50ef3', // yevhenii
  '4d205514-421b-4b77-bff7-4ffe107e53d1', // stas
  'f49f9dd5-a1ec-4095-a9d2-6529717f6d40', // hryhorii algoteryx
  '613e4658-00de-44c3-899a-2e85965db2d1', // support2
];

export { GPT_MANAGEMENT_SUPPORT_IDS, HIGH_PRIVILEGE_SUPPORT_IDS };
